<template>
	<div ref="container" style="width: 100%; height: 100%;"></div>
</template>

<script>
import BanReaperWidget from '@/widgets/BanReaperWidget';
import previewConfig from '@/previewConfig';

// Sample avatars bundled for previews only — the real widget always uses the
// banned chatter's actual avatar from the live event.
const PREVIEW_AVATARS = [
	'backseat_gamer', 'caps_lock', 'cat_lover_22', 'chill_vibes', 'clip_it',
	'curious_mind', 'emoji_flood', 'emote_king', 'end_of_list', 'friendly_fan',
	'game_master_77', 'hype_train', 'laggy_player', 'late_joiner', 'link_dropper',
	'luna_star', 'night_owl', 'noob_slayer', 'pixel_ninja',
	'pro_gamer_x', 'question_mark', 'silent_watcher', 'spam_bot_9k', 'speed_runner',
	'supporter_99', 'tech_guy', 'toxic_dude', 'viewer_123',
].map(name => `/img/avatars/${name}.jpg`);

function pickRandom(arr) {
	return arr[Math.floor(Math.random() * arr.length)];
}

let msgIdCounter = 0;

export default {
	name: 'BanReaperWidgetPreview',
	props: {
		settings: { type: Object, default: () => ({}) },
	},
	data() {
		return { previewTimeoutId: null };
	},
	watch: {
		settings: {
			deep: true,
			handler(s) { this._applySettings(s); },
		},
	},
	mounted() {
		this._initWidget();
		this._startPreview();
	},
	beforeDestroy() {
		this._stopPreview();
		this._destroyWidget();
	},
	methods: {
		async _initWidget() {
			this.widget = new BanReaperWidget({ container: this.$refs.container });
			await this.widget.init({ settings: { ...this.settings } });
		},
		_destroyWidget() {
			if(this.widget) {
				this.widget.destroy();
				this.widget = null;
				if(this.$refs.container) this.$refs.container.innerHTML = '';
			}
		},
		_applySettings(s) {
			if(!this.widget) return;
			this.widget.applySettings({ ...s });
		},
		_startPreview() {
			const schedule = () => {
				this.fireTestBan();
				const delay = 3000 + Math.random() * 4000;
				this.previewTimeoutId = setTimeout(schedule, delay);
			};
			this.previewTimeoutId = setTimeout(schedule, 800);
		},
		_stopPreview() {
			if(this.previewTimeoutId) {
				clearTimeout(this.previewTimeoutId);
				this.previewTimeoutId = null;
			}
		},
		fireTestBan() {
			if(!this.widget) return;

			const username = pickRandom(previewConfig.usernames);
			const hasAvatar = Math.random() < 0.85;
			const avatar = hasAvatar ? pickRandom(PREVIEW_AVATARS) : null;

			const mods = (this.settings.moderators || []).filter(m => m.id || m.username);
			const useMod = mods.length && Math.random() < 0.7;
			const bannedBy = useMod ? (() => {
				const m = pickRandom(mods);
				return { id: m.id || undefined, displayName: m.username || m.id };
			})() : null;

			const isTimeout = Math.random() < 0.4;

			this.widget.onBanEvent({
				id: `preview-${++msgIdCounter}`,
				type: isTimeout ? 'timeout' : 'ban',
				seconds: isTimeout ? pickRandom([30, 60, 300, 600]) : undefined,
				sender: { displayName: username, avatar },
				bannedBy,
			});
		},
	},
};
</script>
